export function generateRandomID(idLength) {
    let l = idLength || 1
    let n = (~~(Math.random() * (l - 1)) + 1)
    if (n > 4) {
        n = 4
    }
    let m = l - n
    return `${Math.random().toString(36).substr(2, m)}${Date.now().
        toString(36).
        substr(4, n)}`
}

const HeadEle = document.head
/** @param tagName{ string }
 *  @param attributeList {{ key:string, value: string }[]}
 * */
export function updateHeadTags(tagName, attributeList) {
    const tagEle = document.createElement(tagName)
    attributeList.map(item => {
        tagEle.setAttribute(item.key, item.value)
    })
    HeadEle.appendChild(tagEle)
}
